module.exports = __webpack_public_path__ + "img/under-construction-illustration.c9daed14.svg";